import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import classes from '../../css/getCSS';


const actionDialog = (props) => {
  let content = null;
  if (props.actionType === 'delete') {
    content = (
      <DialogContentText>
        Are you sure you want to delete this? You cannot undo this action.
      </DialogContentText>
    );
  }

  if (props.actionType === 'accept') {
    content = (
      <DialogContentText>
        You are about to accept this interest/request. <br />
        Your full profile including your contact details will be visible to the candidate. <br />
      </DialogContentText>
    );
  }

  if (props.actionType === 'reject') {
    content = (
      <DialogContentText>
        You are about to reject this interest/request. <br />
      </DialogContentText>
    );
  }

  if (props.actionType === 'save-search') {
    content = (
      <DialogContentText>
        Are you sure you want to save this search?
      </DialogContentText>
    );
  }

  if (props.actionType === 'event') {
    content = (
      <DialogContentText>
        You are about to register for an event! <br />
        You will get a confirmation mail for the same. <br />
        Please note that registering and not showing up on the event&nbsp;
        will result in account deactivation. <br />
      </DialogContentText>
    );
  }

  if (props.loading) {
    content = (
      <div align="center">
        <CircularProgress align="center" size={50} /> <br />
        <Typography variant="body1">Loading. Please wait</Typography>
      </div>
    );
  }

  let errorAlert = null;
  if (props.actionError && !props.successMsg) {
    errorAlert = <Alert type="danger">{props.actionError}</Alert>;
  }

  if (props.successMsg) {
    content = (
      <DialogContentText>
        {props.successMsg}
      </DialogContentText>
    );
  }

  let confirmButton = null;

  if (props.confirmVisible) {
    confirmButton = (
      <Button onClick={props.confirm} color="primary" autoFocus>
        Yes
      </Button>
    );
  }

  return (
    <Dialog
      fullWidth
      open={props.open}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.dialogCard,
      }}
    >
      <DialogTitle id="alert-dialog-title">Please Confirm</DialogTitle>
      <DialogContent>
        {content}
        {errorAlert}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close} color="primary">
          Cancel
        </Button>
        {confirmButton}
      </DialogActions>
    </Dialog>
  );
};

export default actionDialog;



// WEBPACK FOOTER //
// ./src/activities/components/ActionDialog.js